<div class="position-relative">
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="panel-title">{{message && statusMessage=='Expired'? 'Your password expired':message ?'You logged in with your default password, Please change it here':'Change Password'}}</div>
  <div class="modal-form d-flex"  [formGroup]="passwordForm">
    <mat-form-field *ngIf="statusMessage=='Expired' || !message">
      <mat-label>Old Password</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" autocomplete="new-password" formControlName="oldPassword">
      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <ng-container *ngIf="submitted &&  passwordFormValues['oldPassword'].errors">
        <mat-error *ngIf="passwordFormValues['oldPassword'].errors?.['required']">
            <em
             class="fas fa-exclamation-circle mr-2"></em>Old Password is required
        </mat-error>
     </ng-container>
    </mat-form-field>
    <app-password-form formControlName="password" (keyup.enter)="onSubmit()"></app-password-form>
    <div> <span class="ft-12">Note : Use 8 or more characters with a combination of Upper case and lower case letters, numbers & symbols</span></div>
    <div class="d-flex justify-content-center">
      <div class="err-mssg-domain text-danger mb-2" *ngIf="submitted && errorMessage">
         <em class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
   </div>
    <div class="btn-basket">
      <button mat-raised-button color="primary" (click)="onSubmit()">Change Password</button>
    </div>
  </div>
</div>